export const store = {
    _origin: 'https://api.emailjs.com',
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@emailjs/browser/es/store/store.js
// module id = 77
// module chunks = 0